import { render } from "./UserWidget.vue?vue&type=template&id=6eb762d0"
import script from "./UserWidget.vue?vue&type=script&lang=js"
export * from "./UserWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/3nb/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/UserWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eb762d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eb762d0', __exports__)) {
    console.log('reload')
    api.reload('6eb762d0', __exports__)
  }
  
  module.hot.accept("./UserWidget.vue?vue&type=template&id=6eb762d0", () => {
    console.log('re-render')
    api.rerender('6eb762d0', render)
  })

}


export default __exports__